module.exports = __webpack_public_path__ + "static/colors-tagging-bold-dont-4c6414b2d4812ebdb93db61525b3d2d6.png";